import React from 'react';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import FormContainer from 'components/FormContainer';
import ShowInformation from 'components/ShowInformation';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const MetaInformation = ({created, origin}) => {
  
  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">META INFORMATION</div>
      </CardHeader>
      <FormContainer>
        <ShowInformation width={'50%'} title="CREATED" description={moment(created).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')} />
        <ShowInformation width={'50%'} title="ORIGIN" description={origin} />
      </FormContainer>
    </Card>
  )
}

export default MetaInformation;
